import { sendErrorLog } from './logClient'
import { ErrorLogSource } from '../@types/errorLog'
import { UserInfoBody } from '../@types/user'

const getUserInfo = async (): Promise<UserInfoBody> => {
  return fetch(`${process.env.RLE_BACKEND_URL}/user-info`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      if (response.status == 404) {
        return {
          email: undefined,
          salutation: undefined,
          firstname: undefined,
          lastname: undefined,
          phoneNumber: undefined,
        }
      }
      throw new Error(`${response.status}`)
    })
    .catch((error) => {
      const errorMessage = `Error while fetching the user info, error: ${error.message}`
      sendErrorLog({
        message: errorMessage,
        source: ErrorLogSource.USER_INFO,
      })
      throw new Error(errorMessage)
    })
}

export { getUserInfo }
